import React, { useId } from "react"
import clsx from "clsx"
import { useField } from "formik"

type Props = {
  label?: string
  placeholder?: string
  name: string
  className?: string
  rows?: number
}

const FormikTextarea: React.FC<Props> = ({
  label,
  placeholder,
  className = "",
  ...props
}) => {
  const [field, meta] = useField(props)
  const id = useId()

  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className={clsx({ "text-danger": meta.error && meta.touched })}
        >
          {label}
        </label>
      )}
      <textarea
        className={clsx("form-control", className, {
          "is-invalid": meta.error && meta.touched,
        })}
        id={id}
        placeholder={placeholder}
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <span className="invalid-feedback d-inline-block">{meta.error}</span>
      )}
    </div>
  )
}

export default FormikTextarea
